import { de, enUS, Locale } from 'date-fns/locale'

export const languageCodes = ['en', 'de'] as const

export type LanguageCode = (typeof languageCodes)[number]

export const isValidLanguageCode = (input: unknown): input is LanguageCode =>
  typeof input === 'string' && languageCodes.some((item) => item === input)

export type Language = {
  code: LanguageCode
  name: string
  locale: Locale
}

export const supportedLanguages: Language[] = [
  { code: 'en', name: 'English', locale: enUS },
  { code: 'de', name: 'Deutsch', locale: de },
]
